import $ from 'jquery';

const pubsub = $({});

let queue = [];
const listeners = {};

function addListener(event, listener) {
    if (!listeners[event]) {
        listeners[event] = [listener];
    } else {
        listeners[event].push(listener);
    }
}

function hasListener(event) {
    return listeners[event] && listeners[event].length > 0;
}

function removeListener(event, listener) {
    if (!hasListener(event)) {
        return;
    }

    if (listener) {
        listeners[event] = listeners[event].filter(l => l !== listener);
    } else {
        listeners[event] = null;
    }
}

function checkQueue(event) {
    if (queue.length) {
        queue = queue.filter((triggeredEvent) => {
            if (event === triggeredEvent.event) {
                pubsub.trigger(triggeredEvent.event, triggeredEvent.data);

                return false;
            }

            return true;
        });
    }
}

$.subscribe = function(event, listener) {
    pubsub.on(event, listener);

    addListener(event, listener);
    checkQueue(event);
};

$.subscribeOnce = function(event, listener) {
    pubsub.one(event, (e, data) => {
        listener(e, data);
        removeListener(event, listener);
    });
};

$.unsubscribe = function(event, listener) {
    pubsub.off(event, listener);

    removeListener(event, listener);
};

$.publish = function(event, data) {
    if (!hasListener(event)) {
        queue.push({ event, data });
    }

    pubsub.trigger(event, data);
};



/** WEBPACK FOOTER **
 ** ./legacy/others/pubsub.js
 **/